<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p2LSrh/tc-custom/9781452121819.jpg?1726519075142" alt="This image is the cover for the book Gluten-Free Baking for the Holidays"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gluten-Free Baking for the Holidays
      </h1>
      <p class="bookDescription body article font2">
        <b>“Recipes for everything from spritz cookies to bûche de Noël . . . shatters the assumption that if you can’t eat wheat, you can’t eat well during the holidays.” —<i>San Jose Mercury News</i></b><br/><br/>The holidays are a time to celebrate and indulge in baked goods warm from the oven. Unfortunately for the gluten-sensitive, seasonal pleasures such as sugar cookies and mincemeat tarts have been off-limits. Not anymore! <br/><br/>Jeanne Sauvage, author of the popular blog Art of Gluten-Free Baking, has perfected 60 gluten-free recipes with all the flavors of their wheat-filled counterparts. Also included are tips on how wheat-free ingredients work and Jeanne’s own gluten-free flour mix. With favorites like apple pie, plum pudding, rugelach, bûche de Noël—even a gingerbread house—everyone can pull up a chair to the holiday table with comfort and joy.<br/><br/>“Her cookies and cakes and other treats (and I have reached for many a second helping at various Seattle events over the years) are reliably the best on the table even when they’re up against traditional gluten-full baked goods.” —<i>Seattle Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeanne Sauvage, Clare Barboza
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b35bdb0